// store.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 初始化结构：数组包含多个currency分组对象
    favorites: JSON.parse(localStorage.getItem('favorites')) || []
  },
  mutations: {
    // 添加收藏
    ADD_FAVORITE(state, { currency, item }) {
      // 查找对应currency的分组
      let currencyGroup = state.favorites.find(
        (group) => group.currency === currency
      )

      // 如果该currency分组不存在，创建新分组
      if (!currencyGroup) {
        currencyGroup = {
          currency: currency,
          list: []
        }
        state.favorites.push(currencyGroup)
      }

      // 检查是否已收藏，避免重复添加
      const isExist = currencyGroup.list.some((fav) => fav.gid === item.gid)
      if (!isExist) {
        currencyGroup.list.push(item)
        localStorage.setItem('favorites', JSON.stringify(state.favorites))
      }
    },
    // 删除收藏
    REMOVE_FAVORITE(state, { currency, item }) {
      // 查找对应currency的分组
      const currencyGroup = state.favorites.find(
        (group) => group.currency === currency
      )

      if (currencyGroup) {
        // 找到要删除的项的索引
        const index = currencyGroup.list.findIndex(
          (fav) => fav.gid === item.gid
        )
        if (index !== -1) {
          currencyGroup.list.splice(index, 1)
          // 如果分组下没有收藏项了，可以选择删除该分组（可选）
          if (currencyGroup.list.length === 0) {
            const groupIndex = state.favorites.findIndex(
              (group) => group.currency === currency
            )
            state.favorites.splice(groupIndex, 1)
          }
          localStorage.setItem('favorites', JSON.stringify(state.favorites))
        }
      }
    }
  },
  actions: {
    addFavorite({ commit }, payload) {
      commit('ADD_FAVORITE', payload)
    },
    removeFavorite({ commit }, payload) {
      commit('REMOVE_FAVORITE', payload)
    }
  }
})

export default store
